export default "__VITE_ASSET__B$Ue4yTL__"